import { apiGet } from '@/shared/utils/requestBuilder';
import type {
  ClasseJudicial,
  ClasseJudicialFilters,
  Grau,
  TipoJustica,
} from '@/types/classeJudicial/classeJudicialTypes';

export const classeJudicialService = {
  listar: async (
    filters?: ClasseJudicialFilters,
  ): Promise<{ data: ClasseJudicial[]; total: number }> => {
    const params = new URLSearchParams();
    if (filters?.search) params.append('search', filters.search);
    if (filters?.ativo !== undefined) params.append('ativo', String(filters.ativo));
    if (filters?.page) params.append('page', String(filters.page));
    if (filters?.limit) params.append('limit', String(filters.limit));

    const query = params.toString() ? `?${params.toString()}` : '';
    const response = await apiGet(`/classes-judiciais${query}`);

    if (!response.ok) {
      const errorData = await response
        .json()
        .catch(() => ({ error: 'Erro ao listar classes judiciais' }));
      throw new Error(errorData.error || 'Erro ao listar classes judiciais');
    }

    const result = await response.json();
    const payload = result?.data && Array.isArray(result?.data?.data) ? result.data : result;
    return {
      data: (payload?.data as ClasseJudicial[]) || [],
      total: (payload?.total as number) || 0,
    };
  },

  buscarPorId: async (id: string): Promise<ClasseJudicial> => {
    const response = await apiGet(`/classes-judiciais/${id}`);

    if (!response.ok) {
      const errorData = await response
        .json()
        .catch(() => ({ error: 'Classe judicial não encontrada' }));
      throw new Error(errorData.error || 'Classe judicial não encontrada');
    }

    const result = await response.json();
    return result.data;
  },

  buscarPorTipoJusticaEGrau: async (
    tipoJustica: TipoJustica,
    grau: Grau,
  ): Promise<{ data: ClasseJudicial[]; total: number }> => {
    const response = await apiGet(`/classes-judiciais/tipo/${tipoJustica}/grau/${grau}`);

    if (!response.ok) {
      const errorData = await response
        .json()
        .catch(() => ({ error: 'Erro ao buscar classes judiciais' }));
      throw new Error(errorData.error || 'Erro ao buscar classes judiciais');
    }

    const result = await response.json();
    const payload = result?.data && Array.isArray(result?.data?.data) ? result.data : result;
    return {
      data: (payload?.data as ClasseJudicial[]) || [],
      total: (payload?.total as number) || 0,
    };
  },

  buscarPorCodigo: async (codigo: string): Promise<ClasseJudicial> => {
    const response = await apiGet(`/classes-judiciais/codigo/${codigo}`);

    if (!response.ok) {
      const errorData = await response
        .json()
        .catch(() => ({ error: 'Classe judicial não encontrada' }));
      throw new Error(errorData.error || 'Classe judicial não encontrada');
    }

    const result = await response.json();
    return result.data;
  },
};
